import React from 'react';
import { ContactInfoFieldKeyType } from 'typings/form';
import { ContactFieldRow } from 'components/common/ContactFieldRow';
import { Button, Col, ContactPersonDrawer, IconWrapper, Row, Spin, Typography } from 'components';
import { useContactPersons } from './useContactPersons';
import detailsStyles from '../styles.module.scss';
import styles from './styles.module.scss';

export const ContactPersons: React.FC = () => {
  const { isLoading, contactPersons, drawerVisible, toggleDrawer, toggleExpandPerson, isPersonExpanded } =
    useContactPersons();

  const mainContactPerson = contactPersons[0] || {};
  const contactEntries = Object.entries(mainContactPerson?.contacts || {}) as [ContactInfoFieldKeyType, string[]][];

  return (
    <>
      <Col span={24} className={detailsStyles.main_info}>
        <Spin spinning={isLoading}>
          <Row>
            <Col span={24}>
              <Typography.Text className={styles.title}>Contact Person</Typography.Text>
            </Col>
          </Row>
          <Row gutter={[0, 4]} className={styles.contact_persons}>
            <Col span={24}>
              <Row justify={'space-between'} align={'middle'}>
                <Col>
                  <Row className={styles.name_flag_container} align={'middle'}>
                    <Typography.Text type={'secondary'}>{mainContactPerson?.fullName}</Typography.Text>
                    {mainContactPerson?.language?.flagLocation && (
                      <IconWrapper src={mainContactPerson?.language?.flagLocation} />
                    )}
                  </Row>
                </Col>
              </Row>
            </Col>

            {mainContactPerson?.department && (
              <Col span={24}>
                <Row justify={'space-between'}>
                  <Col>
                    <Typography.Text type={'secondary'}>Department</Typography.Text>
                  </Col>
                  <Col>
                    <Typography.Text type={'secondary'}>{mainContactPerson.department}</Typography.Text>
                  </Col>
                </Row>
              </Col>
            )}

            {mainContactPerson.role && (
              <Col span={24}>
                <Row justify={'space-between'}>
                  <Col>
                    <Typography.Text type={'secondary'}>Role</Typography.Text>
                  </Col>
                  <Col>
                    <Typography.Text type={'secondary'}>{mainContactPerson.role}</Typography.Text>
                  </Col>
                </Row>
              </Col>
            )}

            {contactEntries.slice(0, 3).map(([type, values]) => (
              <ContactFieldRow key={type} fieldValueMaxWidth={150} type={type} data={values} />
            ))}

            {contactPersons.length > 1 && (
              <Col span={24}>
                <Row align={'middle'} justify={'end'}>
                  <Col>
                    <Button type={'link'} variant={'link'} className={styles.see_all_button} onClick={toggleDrawer}>
                      See All
                    </Button>
                  </Col>
                </Row>
              </Col>
            )}
          </Row>
        </Spin>
      </Col>
      <ContactPersonDrawer
        visible={drawerVisible}
        onClose={toggleDrawer}
        contactPersons={contactPersons}
        toggleExpandPerson={toggleExpandPerson}
        isPersonExpanded={isPersonExpanded}
      />
    </>
  );
};
